import { z } from "zod"
import { SHIPPING_COUNTRY_CODES, ShippingCountryCode } from "./shipping-country-code"

/**
 * The reason some are empty strings is because their currency is EUR.
 */
export const CENTRA_LOCALE_SHIPPING_COUNTRY_CODES = {
    [SHIPPING_COUNTRY_CODES.Austria]: "",
    [SHIPPING_COUNTRY_CODES.Belgium]: "",
    [SHIPPING_COUNTRY_CODES.Bulgaria]: "",
    [SHIPPING_COUNTRY_CODES.Croatia]: "",
    [SHIPPING_COUNTRY_CODES.Cyprus]: "",
    [SHIPPING_COUNTRY_CODES.CzechRepublic]: SHIPPING_COUNTRY_CODES.CzechRepublic,
    [SHIPPING_COUNTRY_CODES.Denmark]: SHIPPING_COUNTRY_CODES.Denmark,
    [SHIPPING_COUNTRY_CODES.Estonia]: "",
    [SHIPPING_COUNTRY_CODES.Finland]: "",
    [SHIPPING_COUNTRY_CODES.France]: "",
    [SHIPPING_COUNTRY_CODES.Germany]: "",
    [SHIPPING_COUNTRY_CODES.Greece]: "",
    [SHIPPING_COUNTRY_CODES.Hungary]: "",
    [SHIPPING_COUNTRY_CODES.Ireland]: "",
    [SHIPPING_COUNTRY_CODES.Italy]: "",
    [SHIPPING_COUNTRY_CODES.Latvia]: "",
    [SHIPPING_COUNTRY_CODES.Lithuania]: "",
    [SHIPPING_COUNTRY_CODES.Luxembourg]: "",
    [SHIPPING_COUNTRY_CODES.Malta]: "",
    [SHIPPING_COUNTRY_CODES.Netherlands]: "",
    [SHIPPING_COUNTRY_CODES.Norway]: SHIPPING_COUNTRY_CODES.Norway,
    [SHIPPING_COUNTRY_CODES.Poland]: SHIPPING_COUNTRY_CODES.Poland,
    [SHIPPING_COUNTRY_CODES.Portugal]: "",
    [SHIPPING_COUNTRY_CODES.Romania]: "",
    [SHIPPING_COUNTRY_CODES.Slovakia]: "",
    [SHIPPING_COUNTRY_CODES.Slovenia]: "",
    [SHIPPING_COUNTRY_CODES.Spain]: "",
    [SHIPPING_COUNTRY_CODES.Sweden]: SHIPPING_COUNTRY_CODES.Sweden,
    [SHIPPING_COUNTRY_CODES.Switzerland]: SHIPPING_COUNTRY_CODES.Switzerland,
    [SHIPPING_COUNTRY_CODES.UnitedKingdom]: SHIPPING_COUNTRY_CODES.UnitedKingdom,
    [SHIPPING_COUNTRY_CODES.Canada]: SHIPPING_COUNTRY_CODES.Canada,
    [SHIPPING_COUNTRY_CODES.USA]: SHIPPING_COUNTRY_CODES.USA,
    [SHIPPING_COUNTRY_CODES.Australia]: SHIPPING_COUNTRY_CODES.Australia,
    [SHIPPING_COUNTRY_CODES.NewZealand]: SHIPPING_COUNTRY_CODES.NewZealand,
    [SHIPPING_COUNTRY_CODES.Japan]: SHIPPING_COUNTRY_CODES.Japan
} as const

export type CentraLocaleShippingCountryCode =
    (typeof CENTRA_LOCALE_SHIPPING_COUNTRY_CODES)[keyof typeof CENTRA_LOCALE_SHIPPING_COUNTRY_CODES]

export const isCentraLocaleShippingCountryCode = (
    value: string,
    centraLocaleShippingCountryCodes: typeof CENTRA_LOCALE_SHIPPING_COUNTRY_CODES
): value is CentraLocaleShippingCountryCode => {
    return Object.values(centraLocaleShippingCountryCodes).includes(
        value as CentraLocaleShippingCountryCode
    )
}

export const getShippingCountryCodeByCentraLocaleShippingCountryCode = (
    centraLocaleShippingCountryCode: CentraLocaleShippingCountryCode,
    centraLocaleShippingCountryCodes: typeof CENTRA_LOCALE_SHIPPING_COUNTRY_CODES
): ShippingCountryCode | undefined => {
    const foundEntry = Object.entries(centraLocaleShippingCountryCodes).find(
        ([_, code]) => code === centraLocaleShippingCountryCode
    )

    return foundEntry ? (foundEntry[0] as ShippingCountryCode) : undefined
}

/* Zod Runtime Types For Centra Locale Shipping Country Code */

const allCentraLocaleShippingCountryCodes = Object.values(
    CENTRA_LOCALE_SHIPPING_COUNTRY_CODES
) as [CentraLocaleShippingCountryCode, ...CentraLocaleShippingCountryCode[]]

const CentraLocaleShippingCountryCodeSchema = z.enum(allCentraLocaleShippingCountryCodes)

export const validateCentraLocaleShippingCountryCode = (code: string) =>
    CentraLocaleShippingCountryCodeSchema.safeParse(code.toLowerCase())
